module.exports = __webpack_public_path__ + "img/icon_info.d24c2984.svg";